import React from "react";
import threedotsicon from "../../../assets/images/threedotsicon.svg";
import printdropdownicon from "../../../assets/images/printdropdownicon.svg";
import { Dropdown, ProgressBar, Table } from "react-bootstrap";
import "./caseloadindependence.css";

const Caseloadindependence: React.FC = () => {
  return (
    <>
      <div className="common_card">
        <div className="top ">
          <div className="dots_flx">
            <div className="top_bar_tittle">
              <h2>Caseload Independence Metric</h2>
            </div>
            <Dropdown className='my_dropdown my_dropdown_dots'>
              <Dropdown.Toggle variant="success" id="dropdown-basic">
                <img style={{width: '1.5rem'}} src={threedotsicon} alt="threedotsicon" />
              </Dropdown.Toggle>
              <Dropdown.Menu align='end'>
                <Dropdown.Item href="/"><img src={printdropdownicon} alt="printdropdownicon" /> Print</Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          </div>
        </div>
        <Table responsive className="common_table">
          <thead>
            <tr>
              <th>Participant Name</th>
              <th>Goals Met (%)</th>
              <th>Service Activation (%)</th>
              <th>Resource Utilization (%)</th>
              <th>Social Engagement (%)</th>
              <th className="empowerment_score_th">Empowerment Score</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Jane Doe</td>
              <td>
                <div className="progress_bar_flx">
                  <ProgressBar>
                    <ProgressBar
                      variant="success"
                      now={30}
                      key={1}
                      label={`${30}%`}
                    />
                  </ProgressBar>
                </div>
              </td>
              <td>100%</td>
              <td>87%</td>
              <td>87%</td>
              <td className="empowerment_score_td">87%</td>
            </tr>
            <tr>
              <td>Jane Doe</td>
              <td>
                <div className="progress_bar_flx">
                  <ProgressBar>
                    <ProgressBar
                      variant="success"
                      now={30}
                      key={1}
                      label={`${30}%`}
                    />
                  </ProgressBar>
                </div>
              </td>
              <td>100%</td>
              <td>87%</td>
              <td>87%</td>
              <td className="empowerment_score_td">87%</td>
            </tr>
            <tr>
              <td>Jane Doe</td>
              <td>
                <div className="progress_bar_flx">
                  <ProgressBar>
                    <ProgressBar
                      variant="success"
                      now={30}
                      key={1}
                      label={`${30}%`}
                    />
                  </ProgressBar>
                </div>
              </td>
              <td>100%</td>
              <td>87%</td>
              <td>87%</td>
              <td className="empowerment_score_td">87%</td>
            </tr>
            <tr>
              <td>Jane Doe</td>
              <td>
                <div className="progress_bar_flx">
                  <ProgressBar>
                    <ProgressBar
                      variant="success"
                      now={30}
                      key={1}
                      label={`${30}%`}
                    />
                  </ProgressBar>
                </div>
              </td>
              <td>100%</td>
              <td>87%</td>
              <td>87%</td>
              <td className="empowerment_score_td">87%</td>
            </tr>
            <tr>
              <td>Jane Doe</td>
              <td>
                <div className="progress_bar_flx">
                  <ProgressBar>
                    <ProgressBar
                      variant="success"
                      now={30}
                      key={1}
                      label={`${30}%`}
                    />
                  </ProgressBar>
                </div>
              </td>
              <td>100%</td>
              <td>87%</td>
              <td>87%</td>
              <td className="empowerment_score_td">87%</td>
            </tr>
            <tr>
              <td>Jane Doe</td>
              <td>
                <div className="progress_bar_flx">
                  <ProgressBar>
                    <ProgressBar
                      variant="success"
                      now={30}
                      key={1}
                      label={`${30}%`}
                    />
                  </ProgressBar>
                </div>
              </td>
              <td>100%</td>
              <td>87%</td>
              <td>87%</td>
              <td className="empowerment_score_td">87%</td>
            </tr>
            <tr>
              <td>Jane Doe</td>
              <td>
                <div className="progress_bar_flx">
                  <ProgressBar>
                    <ProgressBar
                      variant="success"
                      now={30}
                      key={1}
                      label={`${30}%`}
                    />
                  </ProgressBar>
                </div>
              </td>
              <td>100%</td>
              <td>87%</td>
              <td>87%</td>
              <td className="empowerment_score_td">87%</td>
            </tr>
            <tr>
              <td>Jane Doe</td>
              <td>
                <div className="progress_bar_flx">
                  <ProgressBar>
                    <ProgressBar
                      variant="success"
                      now={30}
                      key={1}
                      label={`${30}%`}
                    />
                  </ProgressBar>
                </div>
              </td>
              <td>100%</td>
              <td>87%</td>
              <td>87%</td>
              <td className="empowerment_score_td">87%</td>
            </tr>
            <tr>
              <td>Jane Doe</td>
              <td>
                <div className="progress_bar_flx">
                  <ProgressBar>
                    <ProgressBar
                      variant="success"
                      now={30}
                      key={1}
                      label={`${30}%`}
                    />
                  </ProgressBar>
                </div>
              </td>
              <td>100%</td>
              <td>87%</td>
              <td>87%</td>
              <td className="empowerment_score_td">87%</td>
            </tr>
            <tr>
              <td>Jane Doe</td>
              <td>
                <div className="progress_bar_flx">
                  <ProgressBar>
                    <ProgressBar
                      variant="success"
                      now={30}
                      key={1}
                      label={`${30}%`}
                    />
                  </ProgressBar>
                </div>
              </td>
              <td>100%</td>
              <td>87%</td>
              <td>87%</td>
              <td className="empowerment_score_td">87%</td>
            </tr>
            <tr>
              <td>Jane Doe</td>
              <td>
                <div className="progress_bar_flx">
                  <ProgressBar>
                    <ProgressBar
                      variant="success"
                      now={30}
                      key={1}
                      label={`${30}%`}
                    />
                  </ProgressBar>
                </div>
              </td>
              <td>100%</td>
              <td>87%</td>
              <td>87%</td>
              <td className="empowerment_score_td">87%</td>
            </tr>
          </tbody>
        </Table>
      </div>
    </>
  );
};

export default Caseloadindependence;